<footer>
  <span>
    @if (lastUpdate$ | async; as lastUpdated) {
      {{
        'common.label.lastDataUpdate' | translate: { value: lastUpdated | date }
      }}
    }
  </span>
  <span class="copyright">© {{ copyright }}</span>
</footer>
